@if(error) {
  <div class="alert alert-danger">{{error}}</div>
}

<h1 data-automation-name="registeredReportEditor">
  @switch(editing) {
    @case(true) {
      <div class="alert alert-warning">
        Registered Reports should not be edited unless absolutely necessary.
        Generally it is safer to delete the registered report and re-register the original metadata report.
      </div>
      <span>Edit Registered Report {{registeredReportId}}</span>
    }
    @case(false) {
      <span>Register a new Report</span>
    }
  }
</h1>
@if(isLoading) {
  <app-loader
    message="Loading...">
  </app-loader>
} @else {
  <form name="registeredReportForm" class="form-horizontal" [formGroup]="registeredReportForm">
    <div class="form-group">
      <label for="reportRequestId"> Report request id: </label>
      <input id="reportRequestId" class="form-control" name="report_request_id" type="text" formControlName="reportRequestId" required>
      @if(registeredReportForm.get('reportRequestId')?.invalid && (registeredReportForm.get('reportRequestId')?.dirty || registeredReportForm.get('reportRequestId')?.touched)) {
        <div class="text-danger">
          <div *ngIf="registeredReportForm.get('reportRequestId')?.errors?.['required']">Report request ID is required.</div>
        </div>
      }
    </div>

    <div class="form-group">
      <label for="rids"> RIDs: </label>
      <select multiple id="rids" class="form-control" type="select" formControlName="rids" size="10" required>
        @for(rid of rids; track rid) {
          <option [value]="rid.id" [selected]="selectedRids.includes(rid.id)">{{rid.id}}</option>
        }
      </select>
      <div class="text-info">
        Use CTRL + left click to multiselect
      </div>
      @if(registeredReportForm.get('rids')?.invalid && (registeredReportForm.get('rids')?.dirty || registeredReportForm.get('rids')?.touched)) {
        <div class="text-danger">
          <div *ngIf="registeredReportForm.get('rids')?.errors?.['required']">At least one RID must be selected.</div>
        </div>
      }
    </div>

    <div class="form-group">
      <label for="granularity"> Granularity: </label>
      <input name="granularity" required id="granularity" placeholder="PT5M" class="form-control" type="text" formControlName="granularity">
      @if(registeredReportForm.get('granularity')?.invalid && (registeredReportForm.get('granularity')?.dirty || registeredReportForm.get('granularity')?.touched)) {
        <div class="text-danger">
          <div *ngIf="registeredReportForm.get('granularity')?.errors?.['required']">Granularity is required.</div>
        </div>
      }
    </div>

    <div class="form-group">
      <label for="report_back_duration"> Report back duration: </label>
      <input name="report_back_duration" required id="report_back_duration" placeholder="PT1H" class="form-control" type="text" formControlName="reportBackDuration">
      @if(registeredReportForm.get('reportBackDuration')?.invalid && (registeredReportForm.get('reportBackDuration')?.dirty || registeredReportForm.get('reportBackDuration')?.touched)) {
        <div class="text-danger">
          <div *ngIf="registeredReportForm.get('reportBackDuration')?.errors?.['required']">Report back duration is required.</div>
        </div>
      }
    </div>

    <div class="form-group">
      <label for="report_interval_dtstart"> Report interval start date </label>
      <input name="report_interval_dtstart" required id="report_interval_dtstart" placeholder="2016-12-13 12:34:56" class="form-control" type="text" formControlName="reportIntervalDtstart">
      @if(registeredReportForm.get('reportIntervalDtstart')?.invalid && (registeredReportForm.get('reportIntervalDtstart')?.dirty || registeredReportForm.get('reportIntervalDtstart')?.touched)) {
        <div class="text-danger">
          <div *ngIf="registeredReportForm.get('reportIntervalDtstart')?.errors?.['required']">Report interval start date is required.</div>
        </div>
      }
    </div>

    <div class="form-group">
      <label for="report_interval_duration"> Report interval duration (PT0H for forever)</label>
      <input name="report_interval_duration" required id="report_interval_duration" placeholder="PT0H" class="form-control" type="text" formControlName="reportIntervalDuration">
      @if(registeredReportForm.get('reportIntervalDuration')?.invalid && (registeredReportForm.get('reportIntervalDuration')?.dirty || registeredReportForm.get('reportIntervalDuration')?.touched)) {
        <div class="text-danger">
          <div *ngIf="registeredReportForm.get('reportIntervalDuration')?.errors?.['required']">Report interval duration is required.</div>
        </div>
      }
    </div>

    <div class="form-group">
      <label for="report_offset"> (Optional) Report offset: </label>
      <input name="report_offset" id="report_offset" placeholder="PT3H" class="form-control" type="text" formControlName="reportOffset">
    </div>

    <div class="form-group">
      <label for="send_updates" class="form-check-label">(Optional) Send updates?</label>
      <input name="send_updates" id="send_updates"  class="form-check-input" style="margin-left: 8px" type="checkbox" formControlName="sendUpdates">
    </div>

    @if(registeredReportForm.get('sendUpdates')?.value) {
      <div>
        <div class="form-group">
          <label for="update_type"> Update Type: </label>
          <select id="update_type" class="form-control" name="update_type" type="select" formControlName="updateType">
            <option value="scheduled">Scheduled</option>
            <option value="window">Window</option>
          </select>
        </div>

        @if(registeredReportForm.get('updateType')?.value === "scheduled") {
          <div class="form-group">
            <label for="scheduled_update_time"> Time of day to send: </label>
            <input name="scheduled_update_time" id="scheduled_update_time" placeholder="04:00:00" class="form-control" type="text" formControlName="scheduledUpdateTime" required>
          </div>
        }

        @if(registeredReportForm.get('updateType')?.value === "window") {
          <div class="form-group">
            <label for="scheduled_update_duration"> Window duration length: </label>
            <input name="scheduled_update_duration" id="scheduled_update_duration" placeholder="PT3H" class="form-control" type="text" formControlName="scheduledUpdateDuration" required>
          </div>
        }
      </div>
    }

    <div class="row">
      <button id="save" class="btn btn-primary" type="button" (click)="save()" [disabled]="registeredReportForm.invalid">Save</button>
      <a class="btn" (click)="backPage('/registeredReports', router)">Cancel</a>
    </div>
  </form>
}
